/** An icon-only control. `label` is required, because an icon alone is not an accessible name. */

import type { CSSProperties, MouseEvent, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./IconButton.css";

export interface IconButtonProps {
  /** The accessible name, and the tooltip. */
  readonly label: string;
  readonly size?: "sm" | "md" | "lg";
  readonly tone?: "default" | "danger";
  readonly disabled?: boolean;
  readonly onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function IconButton({
  label,
  size = "md",
  tone = "default",
  disabled = false,
  onClick,
  className,
  style,
  children,
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      style={style}
      className={cn("al-iconbutton", `al-iconbutton-${size}`, `al-iconbutton-${tone}`, className)}
    >
      <span aria-hidden="true" className="al-iconbutton-glyph">
        {children}
      </span>
    </button>
  );
}
